export default __webpack_public_path__ + "static/media/google-docs.026077ef.svg";